<template>
  <router-link
    v-if="href"
    :to="href"
    :class="buttonClasses"
    v-bind="$attrs"
    @click="handleClick"
  >
    <slot />
  </router-link>
  <button
    v-else
    :class="buttonClasses"
    :disabled="disabled"
    v-bind="$attrs"
    @click="handleClick"
  >
    <slot />
  </button>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
/* eslint-disable vue/no-reserved-component-names */
export default {
  name: 'Button',
  inheritAttrs: false,
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value)
    },
    variant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'underlined', 'light'].includes(value)
    },
    href: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClasses() {
      const baseClasses = [
        'inline-flex',
        'items-center',
        'justify-center',
        'font-semibold',
        'border-0',
        'no-underline',
        'transition-all',
        'duration-300',
        'focus:outline-none',
        'focus:shadow-none'
      ]

      // Size classes
      const sizeClasses = {
        small: ['text-base', 'w-36', 'h-10'],
        medium: ['text-base', 'w-44', 'h-11'],
        large: ['text-xl', 'w-60', 'h-15', 'px-4', 'leading-15']
      }

      // Variant classes - éviter la référence circulaire avec this.disabled
      const isDisabled = this.disabled
      const variantClasses = {
        primary: [
          'text-white',
          'rounded',
          isDisabled ? 'bg-primview-400 opacity-50 cursor-not-allowed' : 'bg-primview-400 hover:bg-primview-500'
        ],
        underlined: [
          'bg-white',
          'border',
          'border-primview-400',
          'text-primview-400',
          'rounded',
          isDisabled ? 'border-gray-400 text-gray-400 opacity-75 cursor-not-allowed' : 'hover:border-primview-500 hover:text-primview-500'
        ],
        light: [
          'bg-white',
          'text-primview-400',
          'shadow-md',
          'rounded',
          isDisabled ? 'text-gray-400 opacity-75 cursor-not-allowed' : 'hover:shadow-lg hover:text-primview-500'
        ]
      }

      return [
        ...baseClasses,
        ...sizeClasses[this.size] || sizeClasses.medium,
        ...variantClasses[this.variant] || variantClasses.primary
      ].filter(Boolean)
    }
  },
  methods: {
    handleClick(event) {
      if (this.disabled) {
        event.preventDefault()
        return
      }
      this.$emit('click', event)
    }
  }
}
</script>

<style scoped>
/* Styles globaux dans src/assets/styles/components/Widget.scss */
</style>
